export enum RCAAPComplianceRangeEnum {
    "seven" = "7",
    "thirty" = "30",
    "ninety" = "90",
}

export enum RCAAPComplianceByResponsibleFilterEnum {
    "a_to_z_asc" = "A to Z",
    "a_to_z_desc" = "Z to A",
    "low_to_high" = "Low to High",
    "high_to_low" = "High to Low",
}

export enum IRCAAPBarComplianceTypes {
    "completedOnTimeAmount" = "completedOnTimeAmount",
    "pendingAmount" = "pendingAmount",
    "completedLateAmount" = "completedLateAmount",
    "pendingLateAmount" = "pendingLateAmount",
}
